import type { RelatorioV2Row } from '../services/relatorioV2Service'

export type RelatorioV2Metrics = {
  total: number
  tp1Hit: number
  tp2Hit: number
  tp3Hit: number
  stopOnly: number
  unknown: number
  winPct: number
  stopPct: number
}

export function computeMetrics(rows: RelatorioV2Row[]): RelatorioV2Metrics {
  let total = 0
  let tp1Hit = 0
  let tp2Hit = 0
  let tp3Hit = 0
  let stopOnly = 0
  let unknown = 0

  for (const r of rows) {
    total += 1
    const h = deriveHits(r)
    if (h.tp1) tp1Hit += 1
    if (h.tp2) tp2Hit += 1
    if (h.tp3) tp3Hit += 1
    if (h.stopHit && !h.tp1 && !h.tp2 && !h.tp3) stopOnly += 1
    if (!h.tp1 && !h.tp2 && !h.tp3 && !h.stopHit) unknown += 1
  }

  const den = Math.max(1, total)
  return {
    total,
    tp1Hit,
    tp2Hit,
    tp3Hit,
    stopOnly,
    unknown,
    winPct: tp1Hit / den,
    stopPct: stopOnly / den,
  }
}

export function deriveHits(row: RelatorioV2Row): {
  tp1: boolean
  tp2: boolean
  tp3: boolean
  stopHit: boolean
} {
  const snap = row?.snapshotResultType || 'unknown'
  const tp3 = !!row?.tp3Hit || snap === 'tp3'
  const tp2Raw = !!row?.tp2Hit || snap === 'tp2'
  const tp1Raw = !!row?.tp1Hit || snap === 'tp1'
  const stopHit = !!row?.stopHit || snap === 'stop'

  const tp2 = tp2Raw || tp3
  const tp1 = tp1Raw || tp2 || tp3

  return { tp1, tp2, tp3, stopHit }
}
